import { createRouter, createWebHistory } from "vue-router";
import pageRoutes from "./page-routes";
import adminRoutes from "./admin-routes";

const router = createRouter({
  history: createWebHistory(),
  routes: [...pageRoutes, ...adminRoutes],
  scrollBehavior(to, from) {
    if (to.path !== from.path) return { top: 0 };
  },
});

export default router;
